import { render } from "./MultiItemGroupComponent.vue?vue&type=template&id=f876ec6e&scoped=true"
import script from "./MultiItemGroupComponent.vue?vue&type=script&lang=js"
export * from "./MultiItemGroupComponent.vue?vue&type=script&lang=js"

import "./MultiItemGroupComponent.vue?vue&type=style&index=0&id=f876ec6e&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f876ec6e"]])

export default __exports__